import { useEffect, useRef, useState } from "react";
import { renderAsync } from "docx-preview";
import { fetchFileToFileAndBlob } from "@lhd/utility";

export interface IProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  uri?: string;
}

const useWord = (props: IProps) => {
  const { uri, setLoading } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const loadDocx = async () => {
    if (!uri) {
      setLoading(false);
      return;
    }
    const [file] = await fetchFileToFileAndBlob(uri);
    const arrayBuffer = await file.arrayBuffer();
    await renderAsync(arrayBuffer, containerRef.current!, undefined, {
      className: "docx",
      inWrapper: true,
      ignoreWidth: false,
      ignoreHeight: false,
      experimental: true,
      ignoreFonts: false,
    });
    setLoading(false);
  };
  useEffect(() => {
    uri && containerRef.current && loadDocx();
  }, [uri, containerRef.current]);
  return {
    ...props,
    containerRef,
  };
};

export type Props = ReturnType<typeof useWord>;

export default useWord;
